<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">Chi tiết nhà thầu</div>
        <div class="tab">
          <div :class="{ active: currentTab == 0 }" @click="showContent(0)">Thông tin chung</div>
          <div :class="{ active: currentTab == 1 }" @click="showContent(1)">Lịch sử đánh giá</div>
        </div>
        <div :class="{ content : true, active: currentTab == 0 }">
          <formEdit
            v-if="loaded"
            :key="componentKey"
            mode="view"
            :model="models"/>
        </div>
        <div :class="{ content : true, active: currentTab == 1 }">
          <DataTable
            :value="list_evaluate"
            :lazy="true"
            :loading="evaluate_loading"
            class="p-datatable-responsive"
            data-key="id"
            :autoLayout="true"
            :paginator="true"
            @page="onEvaluatePage($event)"
            :totalRecords="evaluate_pagination.total"
            :rows="evaluate_pagination.limit"
            :first="evaluate_pagination.offset"
            :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
            :currentPageReportTemplate="$constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM + ' {totalRecords}'"
            :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
          >
            <Column field="sra_text" header="Gói công việc" headerStyle="min-width: 100px;">
              <template #body="slotProps">{{ slotProps.data.sra_text }}</template>
              <template #filter>
                <InputText
                  type="text"
                  v-model="filters.sra_name"
                  class="p-column-filter"
                  placeholder="Tìm kiếm"
                  @keyup="onFilterText()"
                />
              </template>
            </Column>
            <Column field="date_start_text" header="Từ ngày" headerStyle="min-width: 60px;">
              <template #body="slotProps">{{ slotProps.data.date_start_text }}</template>
              <template #filter>
                <Calendar
                  :showOnFocus="false"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  :yearRange="yearRange"
                  dateFormat="dd/mm/yy"
                  placeholder="Chọn"
                  v-model="filters.date_start"
                  class="p-column-filter"
                  :showIcon="true"
                  selectionMode="range"
                  appendTo="body"
                  :showButtonBar="true"
                  @clear-click="onFilterDate('date_start')"
                  @date-select="onFilterDate('date_start')"
                  :manualInput="false"
                  style="min-width: 60px;"
                />
              </template>
            </Column>
            <Column field="date_end_text" header="Đến ngày" headerStyle="min-width: 60px;">
              <template #body="slotProps">{{ slotProps.data.date_end_text }}</template>
              <template #filter>
                <Calendar
                  :showOnFocus="false"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  :yearRange="yearRange"
                  dateFormat="dd/mm/yy"
                  placeholder="Chọn"
                  v-model="filters.date_end"
                  class="p-column-filter"
                  :showIcon="true"
                  selectionMode="range"
                  appendTo="body"
                  :showButtonBar="true"
                  @clear-click="onFilterDate('date_end')"
                  @date-select="onFilterDate('date_end')"
                  :manualInput="false"
                  style="min-width: 60px;"
                />
              </template>
            </Column>
            <Column field="safe_text" header="An toàn" headerStyle="width: 100px;"></Column>
            <Column field="quality_text" header="Chất lượng" headerStyle="width: 100px;"></Column>
            <Column field="continue_text" header="Tiếp tục" headerStyle="width: 110px;"></Column>
            <Column header="Xếp hạng" headerStyle="width: 140px;text-align: center !important;" bodyStyle="text-align: center !important;">
              <template #body="slotProps">
                <span v-if="slotProps.data.badge" :class="['badge-cs', 'badge-cs-' + slotProps.data.badge]">{{ getBadgeLabel(slotProps.data.badge) }}</span>
              </template>
            </Column>
            <Column field="incidents_text" header="Tai nạn" headerStyle="min-width: 100px;" bodyStyle="white-space: pre-line;"></Column>
            <Column field="violations_text" header="Vi phạm" headerStyle="min-width: 100px;" bodyStyle="white-space: pre-line;"></Column>
            <Column header="Ghi chú">
              <template #body="slotProps">
                <div class="note-cs">{{ slotProps.data.note }}</div>
              </template>
            </Column>
            <Column header="File" headerStyle="min-width: 160px;">
              <template #body="slotProps">
                <div v-if="slotProps.data.files.length > 0" class="profile-file-list">
                  <div v-for="(file, fileIndex) in slotProps.data.files" :key="fileIndex" class="profile-file-row">
                    <a href="#" class="profile-file-link" @click.prevent="viewFile(file)">{{ file.name }}</a>
                    <Button icon="pi pi-download" class="p-button-download p-button-link" @click="downloadFile(file)"/>
                  </div>
                </div>
              </template>
            </Column>
            <template #empty>
              <div class="text-center">{{ $t('datatable.empty') }}</div>
            </template>
            <template #loading>
              <div class="text-center">{{ $t('datatable.loading') }}</div>
            </template>
          </DataTable>
        </div>
        <div class="button-container" style="margin-top: 12px;">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-warning return-style-button" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formEdit from './add'
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      currentTab: 0,
      models: {},
      loaded: false,
      componentKey: 0,
      view_id: null,
      company_id: null,
      yearRange: '2022:' + (new Date().getFullYear() + 100),
      filters: {
        sra_name: '',
        date_start: null,
        date_end: null,
      },
      filterTimeout: null,
      list_evaluate: [],
      evaluate_loading: false,
      evaluate_pagination: {
        offset: 0,
        limit: 10,
        total: 0,
      },
      evaluationRateOptions: [
        { value: 1, label: 'Rất tệ' },
        { value: 2, label: 'Tệ' },
        { value: 3, label: 'Hoàn thành' },
        { value: 4, label: 'Tốt' },
        { value: 5, label: 'Rất tốt' },
      ],
      evaluationContinueOptions: [
        { value: 1, label: 'Không tiếp tục' },
        { value: 2, label: 'Tiếp tục' },
      ],
    }
  },
  async mounted() {
    if (!this.$commonFuction.isEmpty(this.$route.query) && !this.$commonFuction.isEmpty(this.$route.query.company_id)) {
      this.company_id = this.$route.query.company_id;
    }
    this.view_id = this.$route.params.id;
    if (this.view_id !== undefined) {
      await this.getData(this.view_id);
      await this.getListEvaluate();
    }
  },
  methods: {
    getBadgeLabel(badge) {
      const labels = {
        A: 'A - Tốt',
        B: 'B - Trung Bình',
        C: 'C - Tệ',
      }
      return labels[badge] || badge
    },
    getHeaders() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if (!token) {
        return null;
      }
      return { "Authorization": "Bearer " + token };
    },
    showContent(index) {
      this.currentTab = index
    },
    backToList() {
      this.$router.push({ path: '/admin/list-contractor', query: {company_id: this.company_id} });
    },
    async getData(id) {
      const headers = this.getHeaders();
      if (!headers) return;
      var {data} = await ApiRepository.post("/_api/contractor/detail", {id: id, company_id: this.company_id}, {headers});
      this.models = data.data;
      this.loaded = true;
      this.componentKey++;
    },
    getOptionLabel(options, value) {
      var item = options.find(m => m.value == value);
      return item ? item.label : '';
    },
    formatDate(value) {
      return value ? moment(value).format("DD/MM/YYYY") : '';
    },
    // gạch đầu dòng, mỗi mục một dòng: "- Tên 1(số lần)\n- Tên 2(số lần)"
    formatOptions(list = []) {
      return list.map(m => '- ' + m.name + (m.total_count > 0 ? `(${m.total_count})` : '')).join('\n');
    },
    getDateRange(range) {
      if (!range || !range[0]) {
        return null;
      }
      return {
        from: range[0],
        to: range[1] ?? range[0],
      };
    },
    async getListEvaluate() {
      const headers = this.getHeaders();
      if (!headers) return;
      this.evaluate_loading = true;
      var params = {
        contractor_id: this.view_id,
        filters: {
          sra_name: this.filters.sra_name ? this.filters.sra_name.trim() : '',
          date_start: this.getDateRange(this.filters.date_start),
          date_end: this.getDateRange(this.filters.date_end),
        },
        limit: this.evaluate_pagination.limit,
        offset: this.evaluate_pagination.offset,
      }
      if (this.company_id) {
        params.company_id = this.company_id;
      }
      await ApiRepository.post("/_api/contractor/list_evaluate_history", params, {headers}).then((res) => {
        var list = res.data.data?.list ?? [];
        this.list_evaluate = list.map(m => {
          return {
            id: m.id,
            sra_text: m.sra_name ?? '',
            date_start_text: this.formatDate(m.date_start),
            date_end_text: this.formatDate(m.date_end),
            safe_text: this.getOptionLabel(this.evaluationRateOptions, m.safe_value),
            quality_text: this.getOptionLabel(this.evaluationRateOptions, m.quality_value),
            continue_text: this.getOptionLabel(this.evaluationContinueOptions, m.continue_value),
            badge: m.badge ?? null,
            incidents_text: this.formatOptions(m.incidents),
            violations_text: this.formatOptions(m.violations),
            note: m.note ?? '',
            files: m.files ?? [],
          }
        });
        this.evaluate_pagination.total = res.data.data?.total ?? 0;
        this.evaluate_loading = false;
      }).catch((err) => {
        console.log(err);
        this.evaluate_loading = false;
      })
    },
    async onEvaluatePage(event) {
      this.evaluate_pagination.offset = event.first;
      this.evaluate_pagination.limit = event.rows;
      await this.getListEvaluate();
    },
    onFilterText() {
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.evaluate_pagination.offset = 0;
        this.getListEvaluate();
      }, 500);
    },
    async onFilterDate(key) {
      var range = this.filters[key];
      if (range && range[0] && !range[1]) {//chưa chọn đủ khoảng ngày
        return;
      }
      this.evaluate_pagination.offset = 0;
      await this.getListEvaluate();
    },
    downloadFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = file.name || fileUrl.split("?")[0].split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async viewFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null;
      if (!fileUrl) return;

      const fileName = file.name || fileUrl.split("?")[0].split("/").pop() || "";
      const extension = fileName.toLowerCase().split(".").pop();
      const imageMimeTypes = {
        jpg: "image/jpeg", jpeg: "image/jpeg", png: "image/png",
        gif: "image/gif", webp: "image/webp", bmp: "image/bmp",
        svg: "image/svg+xml", tif: "image/tiff", tiff: "image/tiff",
      };
      const isPdf = extension === "pdf";
      const isImage = Object.prototype.hasOwnProperty.call(imageMimeTypes, extension);

      if (!isPdf && !isImage) {
        window.open(fileUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const previewWindow = window.open("", "_blank");
      if (!previewWindow) {
        alert("Vui lòng cho phép trình duyệt mở cửa sổ mới để xem file.");
        return;
      }

      previewWindow.opener = null;

      try {
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error(`Không thể tải file (${response.status})`);

        const blob = await response.blob();
        const previewMimeType = isPdf ? "application/pdf" : imageMimeTypes[extension];
        const previewBlob = blob.type === previewMimeType
          ? blob
          : new Blob([blob], { type: previewMimeType });
        const blobUrl = URL.createObjectURL(previewBlob);

        previewWindow.location.href = blobUrl;
        const cleanupInterval = window.setInterval(() => {
          if (previewWindow.closed) {
            window.clearInterval(cleanupInterval);
            URL.revokeObjectURL(blobUrl);
          }
        }, 5 * 1000);
      } catch (e) {
        previewWindow.close();
        console.error("Lỗi xem file:", e);
        alert("Không thể mở file. Máy chủ lưu file có thể chưa cho phép truy cập CORS.");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.manager-title-custom {
  color: #1D3118;
  font-size: 18px;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EEEEEE;
  font-weight: 700;
}
.tab {
  display: flex;
  font-weight: 700;
  border-bottom: 1px solid #00000029;
}
.tab div {
  padding: 6px 8px;
  cursor: pointer;
}
.tab div.active {
  background-color: #fff;
  color: #0086C4;
  border-left: 1px solid #0086C4;
  border-right: 1px solid #0086C4;
  border-bottom: 3px solid #0086C4;
  border-top: 1px solid #0086C4;
}
.content {
  padding-top: 10px;
  display: none;
}
.content.active {
  display: block;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  .p-button {
    width: auto;
  }
}
.badge-cs {
  display: inline-block;
  min-width: 28px;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;
  font-weight: 700;
}
.badge-cs-A { background-color: green; }
.badge-cs-B { background-color: orange; }
.badge-cs-C { background-color: red; }
.note-cs {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
